import { createContext, use } from "react";

export interface MixpanelContextType {
  track: (
    eventName: string,
    properties?: Record<string, unknown>,
  ) => Promise<void>;
  identify: (userId: string) => Promise<void>;
  setPeople: (properties: Record<string, unknown>) => Promise<void>;
  isLoading: boolean;
}

export const MixpanelContext = createContext<MixpanelContextType | null>(null);

export function useMixpanelContext() {
  const context = use(MixpanelContext);
  if (!context) {
    throw new Error(
      "useMixpanelContext must be used within a MixpanelProvider",
    );
  }
  return context;
}
